<icc-list
    [items]="schemas"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    [selected]="selectedSchemaId$ | async"
    (select)="changeSchema($event)"
></icc-list>
